export default ({
  userAddressRepository,
  maps,
  auth
}) => {
  return async (payload) => {
    const {
      onSuccess,
      onError,
      data,
      actions,
      dispatch
    } = payload

    try {
      const userAddress = await userAddressRepository.delete({
        data,
        actions,
        maps,
        dispatch,
        auth: auth()
      })

      onSuccess({userAddress})
    } catch(e) {
      console.log(e)

      onError()
    }
  }
}
